import { produce } from "immer";

export const actions = (set) => ({
    setBackLinkTitle: (backLinkTitle) => set(produce((state) => {
        state.backNavbar.backLinkTitle = backLinkTitle;
    }), false, 'setBackLinkTitle'),
    setBackNavbarTitle: (title) => set(produce((state) => {
        state.backNavbar.title = title;
    }), false, 'setBackNavbarTitle'),
});
